import {
  Typography,
  Table,
  Button,
  Row,
  Col,
  Divider,
  Space,
  Select,
  message,
  // Popconfirm
} from "antd"
import React, { useEffect, useState } from "react"
import { useCollection } from "../../../hooks/useCollection"
import {
  collection,
  // deleteDoc,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore"
import { db } from "../../../firebase/config"
import { Notification } from "../../../components/Notification"
import { UnconfirmedClientPopup } from "./UnconfirmedClientPopup"
import { UserAddOutlined, UsergroupAddOutlined } from "@ant-design/icons"
import UnconfirmedGroups from "./UnconfirmedGroups"
import { useAuthContext } from "../../../hooks/useAuthContext"
import { AddNotification } from "../../Notifications/AddNotifications"

const { Title } = Typography

export default function UnconfirmedClients() {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const { data: manufactrers, loading: manufacturersLoading } = useCollection("manufacturers")

  const [selectedManufacturer, setSelectedManufacturer] = useState(null)

  //gets users
  const { user } = useAuthContext()

  useEffect(() => {
    setLoading(true)
    const clientsRef = collection(db, "clients")
    const activeQ = query(
      clientsRef,
      where("approved", "==", false),
      where("tapeClient", "==", false)
    )

    const unsubscribe = onSnapshot(activeQ, (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ ...doc.data(), id: doc.id })
      })

      setData(results)
      setLoading(false)
    })

    return () => unsubscribe()
  }, [])

  //add client data
  const updateData = async (e, docid, value) => {
    e.preventDefault()

    if (selectedManufacturer === null) {
      return message.error("Please select manufacturer")
    }

    const ref = doc(db, "clients", docid)
    await updateDoc(ref, {
      approved: true,
      manufacturer: selectedManufacturer,
      status: {
        clientStatus: 1,
        created: value.status.created,
        approved: serverTimestamp(),
        ordered: null,
      },
      paymentStatus: 2,
    })
      .then(() => {
        //adds the notification for the user
        AddNotification(value, "CA", user)
      })
      .then(() => {
        Notification("success", "Updated!", "Client has been approved!")
      })
      .catch((err) => {
        Notification("error", "Error", err.message)
      })
  }

  // //remove client data
  // const removeClient = async (value) => {
  //    await deleteDoc(doc(db, "clients", value.id))
  //       .then(() => {
  //          Notification("success", "Deleted!", "Client has been deleted!");
  //       })
  //       .then(() => {
  //          //adds the notification for the user
  //          AddNotification(value, "CR", user);
  //       })
  //       .catch((error) => {
  //          Notification("error", "Error", error.message);
  //       });
  // };

  const handleManufacturer = (value, option) => {
    setSelectedManufacturer(option)
  }

  const columns = [
    {
      title: "Client",
      dataIndex: "client",
    },
    {
      title: "Group",
      dataIndex: "clientGroup",
    },
    {
      title: "User",
      dataIndex: "userEmail",
      sorter: {
        compare: (a, b) => a.userEmail - b.userEmail,
      },
    },
    {
      width: "15%",
      title: "Manufacturer",
      render: (value, record) => {
        return (
          <Select
            loading={manufacturersLoading}
            fieldNames={{ label: "company", value: "company" }}
            onChange={(value, options) => handleManufacturer(value, options)}
            options={manufactrers}
            value={selectedManufacturer && selectedManufacturer.company}
            placeholder="Select manufacturer..."
            style={{ width: 250 }}
          />
        )
      },
    },
    {
      title: "Profitability",
      dataIndex: "profitability",
      sorter: {
        compare: (a, b) => a.profitability - b.profitability,
      },
      render: (text, value) => <UnconfirmedClientPopup text={text} value={value} />,
    },
    {
      align: "center",
      render: (value) => [
        <Space>
          <Button
            disabled={selectedManufacturer === null ? true : false}
            type="primary"
            onClick={(event) => updateData(event, value.id, value)}>
            Approve!
          </Button>
          {/* <Popconfirm
                  title="Delete this client?"
                  description="Are you sure to delete this ?"
                  onConfirm={() => removeClient(value)}
                  okText="Yes"
                  cancelText="No"
               >
                  <Button type="primary" danger>
                     Delete
                  </Button>
               </Popconfirm> */}
        </Space>,
      ],
    },
  ]
  return (
    <div>
      <Row>
        <Col flex="auto">
          <Title level={2}>
            <UserAddOutlined /> Unconfirmed Clients
          </Title>
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            size="small"
            bordered
            loading={loading}
            dataSource={data}
            pagination={{ defaultPageSize: "10" }}
          />
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col flex="auto">
          <Title level={2}>
            <UsergroupAddOutlined /> Groups
          </Title>
          <UnconfirmedGroups />
        </Col>
      </Row>
    </div>
  )
}
